import { createFileRoute } from "@tanstack/react-router";
import { YdelserPage, ydelserHead } from "@/pages/YdelserPage";

export const Route = createFileRoute("/ydelser")({
  head: () => ydelserHead("da"),
  component: () => <YdelserPage locale="da" />,
});
